import { format } from 'date-fns'
import { XAxis as RechartsXAxis } from 'recharts'

import { getDate } from '../../../app/header/utils'

export const DATE_FORMAT_MMMdd = 'MMM dd'

const TICK_STYLE = {
  fontSize: 10,
  fontWeight: 400, // Different from YAxis
  fill: '',
}

export function dateAxisFormatter({
  value,
  outFormat,
  parseAsNY = true,
}: {
  value: any
  outFormat: string
  parseAsNY?: boolean
}) {
  if (!Number.isFinite(new Date(value).getTime())) return ''

  const date = parseAsNY ? getDate(value) : new Date(value)
  return format(date, outFormat)
}

export class XAxis extends RechartsXAxis {
  static defaultProps = {
    ...RechartsXAxis.defaultProps,
    className: 'fill-gray-500 dark:fill-gray-300',
    tickLine: false,
    axisLine: false,
    dy: 5,
    tick: TICK_STYLE,
  }
}
